export default class Media {
    // index = -1;
    // count = 1;
    constructor({ el }) {
        this.el = el;
        this.wrapper = this.el.querySelector(".wrapper");
        this.slides = gsap.utils.toArray(this.wrapper.querySelectorAll(".wp-block-omnicom-image-grid-item"));
        this.slides.forEach((slide, index) => {
            slide.dataset.index = index
        })
        this.thumbs = gsap.utils.toArray(this.el.querySelectorAll(".thumb"));

        this.initialize();
    }
    getSnapPoints() {
        const offsets = this.slides.map(slide => -slide.offsetLeft + this.el.offsetWidth * 0.5 - slide.offsetWidth * 0.5);
        return offsets;
    }
    getActiveIndex(draggable, snapPoints) {
        const currentX = draggable.x;
        return snapPoints.indexOf(gsap.utils.snap(snapPoints, currentX));
    }
    initialize() {
        const endActivity = () => {
            const snapPoints = this.getSnapPoints();
            const activeIndex = this.getActiveIndex(this.draggable, snapPoints);
            this.focusIdx(activeIndex);
        }
        this.draggable = Draggable.create(this.wrapper, {
            type: "x",
            inertia: true,
            onClick: (e) => {
                const element =  e.srcElement;
                const snapPoints = this.getSnapPoints();
                const activeIndex = this.getActiveIndex(this.draggable, snapPoints);
                const probableIndex = parseInt(element.parentNode.parentNode.dataset.index);
                if (probableIndex !== activeIndex) {
                    const i = probableIndex
                    gsap.to(this.wrapper, { x: snapPoints[i], duration: 1, ease: "expo.out", overwrite: true });
                    this.focusIdx(i);
                } else if (element instanceof HTMLVideoElement) {
                    if (!element.paused && !element.ended) {
                        element.pause();
                        element.parentNode.classList.remove("playing");
                    } else {
                        element.play();
                        element.parentNode.classList.add("playing");
                    }
                }
            },
            onDragEnd: endActivity,
            onThrowUpdate: endActivity,
            onThrowComplete: endActivity,
            invalidateOnRefresh: true,
            snap: { 
                x: (value) => {
                    const snapPoints = this.getSnapPoints();
                    return gsap.utils.snap(snapPoints, value);
                },
            }
        })[0];

        this.boundResize = this.handleResize.bind(this);
        window.addEventListener("resize", this.boundResize);

        const snapPoints = this.getSnapPoints();
        gsap.set(this.wrapper, { x: snapPoints[0]});
        this.focusIdx(0);

        this.thumbs.forEach((thumb, i) => thumb.addEventListener("click", () => {
            const snapPoints = this.getSnapPoints();
            gsap.to(this.wrapper, { x: snapPoints[i], duration: 1, ease: "expo.out", overwrite: true });
            this.focusIdx(i);
        }));
    }
    focusIdx(i) {
        this.thumbs.forEach(thumb => thumb.classList.remove("active"));
        this.thumbs[i].classList.add("active");
        this.slides.forEach(slide => slide.classList.remove("active"));
        this.slides[i].classList.add("active");
    }

    handleResize() {
        const snapPoints = this.getSnapPoints();
        const activeIndex = this.getActiveIndex(this.draggable, snapPoints);
        gsap.set(this.wrapper, { x: snapPoints[activeIndex]})
    }

    dispose() {
        window.removeEventListener("resize", this.boundResize);
    }
}